<style lang="scss" scoped>
@import '../css/sub.scss';
</style>
<template>
  <div class="urban-asset board-page">
    <urban-header></urban-header>
    <div class="urban-sub">
      <div class="board-contents">
        <h2 class="title">서식자료실</h2>
        <div class="search-area">
          <input type="text" class="search-input" @input="itemChanged" placeholder="찾고자하는 게시물을 입력하세요.">
          <button type="button" class="search-btn" @click="searchDocument()"></button>
        </div>
        <div class="board-template">
          <ul class="board-list" v-if="board">
            <li class="list-item" v-for="item in boardList" :key="item.index">
                <span class="label important" v-if="'N' === item.docFreeYn">유료</span>
                <span class="label" v-else>무료</span>
                <span class="tit">{{item.docTitle | truncate(18, '...')}}</span>
              <button type="button" class="item-btn download-btn" @click="boardDetailView(item)">
                다운로드<i class="icon download-icon"></i>
              </button>
            </li>
          </ul>
        </div>
        <div class="popup-template" v-if="boardDetail">
          <div class="popup-container">
            <div class="popup-contents">
              <div class="header">
                <span class="title-column">
                  <span class="label important" v-if="this.detailCharged">유료</span>
                  <span class="label" v-else>무료</span>
                  <span class="tit">{{this.detailTit}}</span>
                </span>
              </div>
              <div class="contents">
                <!--<p class="default-txt">{{this.detailDesc}}</p>-->
                <div class="contents" v-html ="this.detailDesc"></div>
              </div>
              <div class="footer pay-footer">
                <button type="button" class="pay-btn" @click="paying()">{{this.btnStr}}</button>
                <button type="button" class="close-btn" @click="boardDetail = false">닫기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <urban-footer></urban-footer>
  </div>
</template>
<script>
import UrbanHeader from '@/components/UrbanHeader'
import UrbanFooter from '@/components/UrbanFooter'
import { loadTossPayments } from '@tosspayments/sdk'

import { mapGetters } from 'vuex'

const clientKey = 'test_ck_7DLJOpm5Qrlm1Da5J9Q8PNdxbWnY'

export default {
  name: 'ViewReference',
  components: {
    'urban-header': UrbanHeader,
    'urban-footer': UrbanFooter
  },
  data () {
    return {
      board: true,
      listTit: '',
      /* boardList: [
        {id: 1, tit: '안1심매물관리규정 및 관련 정책 개정 안내 (2019.11.11)11111', charged: true},
        {id: 2, tit: '안2심매물관리규정 및 관련 정책 개정 안내 (2019.11.12)', charged: true},
        {id: 3, tit: '안3심매물관리규정 및 관련 정책 개정 안내 (2019.11.13)', charged: false},
        {id: 4, tit: '안4심매물관리규정 및 관련 정책 개정 안내 (2019.11.14)', charged: false},
        {id: 5, tit: '안5심매물관리규정 및 관련 정책 개정 안내 (2019.11.15)', charged: false}
      ], */
      boardDetail: false,
      detailTit: '',
      detailDate: '',
      detailCharged: false,
      detailDesc: '',
      btnStr: '결제하기',
      detailPrice: '',
      detailId: '',
      detailFile: '',
      detailItemCd: '',
      detailStatus: ''
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    this.initDocuments()
  },
  watch: {
    boardList () {
      if (this.$route.params.id !== undefined) {
        var id = parseInt(this.$route.params.id)
        var tmp = ''
        for (var i = 0; i < this.boardList.length; i++) {
          if (this.boardList[i].docId === id) {
            tmp = this.boardList[i]
            break
          }
        }
        if (tmp !== '') {
          this.boardDetailView(tmp)
          this.$route.params.id = undefined
        }
      }
    }
  },
  methods: {
    initDocuments: function () {
      this.$store.dispatch('apiDocuments', {'keyWord': ''})
    },
    itemChanged: function (e) {
      this.board = true
      this.listTit = e.target.value
      this.boardFalse = false
    },
    boardDetailView: function (item) {
      console.log(item)
      this.boardDetail = true
      this.detailTit = item.docTitle
      this.detailDesc = item.docDest
      this.detailPrice = item.docPrice
      this.detailStatus = item.docStatus
      if (item.docFreeYn === 'N') {
        if (this.detailPrice === 0) {
          this.detailCharged = false
        } else {
          this.detailCharged = true
        }
      } else {
        this.detailCharged = false
      }
      this.detailId = item.docId
      this.detailFile = item.docFileNm
      this.detailItemCd = item.docItemCode
      this.orderType = []
      // console.log('this.detailItemCd = ' + this.detailItemCd)
      this.btnTextSetting()
    },
    btnTextSetting () {
      if (this.detailCharged === true) {
        if (this.detailStatus === '') {
          this.btnStr = '결제하기' + '( ￦' + this.detailPrice + ' )'
        } else if (this.detailStatus === 'WAITING_FOR_DEPOSIT') {
          this.btnStr = '결제 대기중'
        } else {
          // DONE 일경우 결제 완료 상태임
          this.btnStr = '다운로드'
        }
      } else {
        this.btnStr = '다운로드'
      }
    },
    paying: function () {
      let loginFlag = this.checkLogin()
      if (!loginFlag) {
        alert('해당 서비스는 로그인 이후 이용가능합니다.')
        return
      }
      if (this.btnStr === '결제 대기중') {
        alert('결제 대기중 입니다.\n결제 후 이용 부탁 드리겠습니다.\n결제 후 다운로드는 MyPage를 통해서도 받을 수 있습니다.')
      } else if (this.btnStr === '다운로드') {
        const params = {
          'gubun': '02',
          'idDownFile': this.detailId,
          'fileName': this.detailFile
        }
        this.$store.dispatch('apiDownFiles', params)
      } else {
        if (!this.checkLogin()) {
          alert('세션 만료 또는 잘못된 접근 입니다.')
          this.$router.push('/Login')
        }
        const ordParams = {
          'clItem': '002',
          'codeItem': this.detailItemCd
        }
        this.$store.dispatch('apigetOrderInfo', ordParams).then(() => {
          if (this.orderType.length === 0) {
            alert('주소 오류로 인하여 내용 변경에 실패하였습니다.')
          } else {
            // console.log(this.orderType.priceItem + ' / ' + this.orderType.orderid + ' / ' + this.orderType.nameItem)
            const params = {
              'docId': this.detailId,
              'ordId': this.orderType.orderid,
              'payId': 1
            }
            sessionStorage.setItem('amount', this.orderType.priceItem)
            sessionStorage.setItem('docPayInfo', JSON.stringify(params))
            // console.log('params = ' + params)
            loadTossPayments(clientKey).then(tossPayments => {
              tossPayments.requestPayment('가상계좌', {
                amount: this.orderType.priceItem,
                orderId: this.orderType.orderid,
                orderName: this.orderType.nameItem,
                customerName: sessionStorage.getItem('name'),
                successUrl: window.location.origin + '/ViewReference/success',
                failUrl: window.location.origin + '/ViewReference/fail'
              })
            })
          }
        })
      }
      // this.boardDetail = false
    },
    searchDocument: function () {
      this.$store.dispatch('apiDocuments', {'keyWord': this.listTit})
    },
    checkLogin () {
      // console.log(sessionStorage.getItem('token'))
      return sessionStorage.getItem('token') !== null
    },
    fetchData () {
      // console.log('hoho')
      // console.log(this.$route.query.orderId)
      if (this.$route.query.code === 'PAY_PROCESS_CANCELED') {
        alert(this.$route.query.message)
      } else {
        // console.log(this.$route.query.orderId)
        if (this.$route.query.orderId !== undefined) {
          if (this.$route.query.amount === sessionStorage.getItem('amount')) {
            // sessionStorage.removeItem('amount')
            // console.log('file-------------s')
            // var arr = JSON.parse(sessionStorage.getItem('params'))
            const amount = sessionStorage.getItem('amount')
            const docInfo = JSON.parse(sessionStorage.getItem('docPayInfo'))
            // console.log(arr)
            // console.log('docInfo = ' + JSON.stringify(docInfo))
            const payparams = {
              'orderId': this.$route.query.orderId,
              'amount': amount,
              'paymentKey': this.$route.query.paymentKey,
              'flag': 'Access',
              'docInfo': docInfo
            }
            this.$store.dispatch('apiDocPayments', payparams).then((res) => {
              sessionStorage.removeItem('amount')
              sessionStorage.removeItem('docPayInfo')
              // console.log('무~야호~')
              // console.log(res)
            })
          } else {
            alert('상품금액이 상이하여 결제가 취소됩니다.')
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      boardList: 'getDocuments',
      orderType: 'getOrderInfo'
    })
    /* filtered: function () {
      let pTit = this.listTit.trim() // 문자열 앞과 뒤 공백제거
      return this.boardList.filter(function (item, index) { // 지정된 조건에 맞는 요소 새롭게 반환
        if (item.tit.indexOf(pTit) !== -1) {
          return true
        }
      })
    } */
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ViewReference.vue